import { TopBar } from '@component/top_bar.component';
import { Auth } from '@feature/auth';

export function ScreenUnauthorized() {
	return (
		<>
			<TopBar.Content onAbort={null} />
			<Auth.Methods returnUrl={window.location.href} />
		</>
	);
}
